export default __webpack_public_path__ + "static/media/metamask-icon.0f5461a6.svg";